/** Keep the two persistent game canvases below Android WebView's texture budget. */
export function gameRenderScale(pixelRatio: number, platform: string | undefined, maximum = 2): number {
  const cap = platform === "android" ? Math.min(maximum, 1.5) : maximum;
  return Math.min(cap, Math.max(1, Number.isFinite(pixelRatio) ? pixelRatio : 1));
}
